import React from 'react';

export const CompatibilityContext = React.createContext({});
